export function user() {
  return JSON.parse(localStorage.getItem("user"))
}

export function currentOrganizationRole(user) {
  if (!user) return null;

  if (isSuperAdmin(user)) {
    return "superAdmin"
  }

  if (!user.selectedOrganization) return null;

  const selectedOrganizationId = user.selectedOrganization?.id
  const selectedOrganizationRole = user?.organizationsRoles?.find((organization) => organization.organizationId === selectedOrganizationId)
  console.log(selectedOrganizationRole)
  return selectedOrganizationRole?.role
}

export function isSuperAdmin(user) {
  return user?.role === "superAdmin"
}


export function isAdmin(user) {
  const role = currentOrganizationRole(user)
  return role === "admin" || role === "superAdmin"
}

export function isNotAdmin(user) {
  const role = currentOrganizationRole(user)
  return role !== "admin" && role !== "superAdmin"
}

export function isNotReader(user) {
  const role = currentOrganizationRole(user)
  return role !== "reader" && role !== "superAdmin"
}

export function isMaintainer(user) {
  const role = currentOrganizationRole(user)
  return role === "maintainer"
}

export function isReader(user) {
  const role = currentOrganizationRole(user)
  return role === "reader"
}

export function isApp() {
  return window.location.hostname.includes("app.")
}

export function isAppAndMaintainer(user) {
  return isApp() && isMaintainer(user)
}
